














	import Vue from 'vue';
	import Component from 'vue-class-component';
	import VCardTemplate from '@/components/maternite/template/VCardTemplate.vue';

	const Props = Vue.extend({
		props: {
			moisgrossesse: {
				type: Number,
				default: 1
			}
		}
	});

	@Component({
        components: {
			VCardTemplate
        }
    })
	export default class Examens extends Props {
	}
